/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getWebhook.defs.js";
export { main as default } from "./getWebhook.defs.js";
